export default "__VITE_ASSET__BBdNgABN__"